import { memo, ReactElement } from 'react';
import { useNavbarHeight } from 'shell/hooks/use-navbar-height';

interface StickyDivProps {
  children: ReactElement | ReactElement[];
}

const StickyDivComponent = ({ children }: StickyDivProps): ReactElement => {
  const height = useNavbarHeight();

  return (
    <div className="pmi-position-sticky pmi-top-0" style={{ top: `${height}px` }}>
      {children}
    </div>
  );
};

StickyDivComponent.displayName = 'Sticky div';

export const StickyDiv = memo(StickyDivComponent) as typeof StickyDivComponent;
